import { useState, createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./App.css";
import CanvasContainer from "./components/CanvasContainer";
import CanvasIcons from "./components/CanvasIcons/CanvasIcons";
import UserInterface from "./components/UserInterface";
import './i18n';

export const WindowContext = createContext({});
export const ConfigurationContext = createContext({});
export const ColorContext = createContext({});
export const WingConfigurationContext = createContext({});

function App() {
  const [currentWindow, setCurrentWindow] = useState("2w");
  const [currentColor, setCurrentColor] = useState("#161616");
  const [documentDirection, setDocumentDirection] = useState("ltr");
  const [currentConfiguration, setCurrentConfiguration] = useState({
    wall: {
      originalWidth: 0,
      originalHeight: 0,
      width: 0,
      height: 0
    },
    window: {}
  });
  const [wingConfiguration, setWingConfiguration] = useState({
    position: 'left-wing',
    horizontalMount: 0,
    verticalMount: 0
  });

  const { i18n } = useTranslation();

  useEffect(() => {
    setDocumentDirection(i18n.dir());
  }, [i18n, i18n.language]);

  return (
    <WindowContext.Provider value={{ currentWindow, setCurrentWindow }}>
      <CanvasIcons />
      <div id="wrapper">
        <ConfigurationContext.Provider value={{ currentConfiguration, setCurrentConfiguration }}>
          <ColorContext.Provider value={{ currentColor, setCurrentColor }}>
            <WingConfigurationContext.Provider value={{ wingConfiguration, setWingConfiguration }}>
              <CanvasContainer />
              <UserInterface documentDirection={documentDirection} />
            </WingConfigurationContext.Provider>
          </ColorContext.Provider>
        </ConfigurationContext.Provider>
      </div>
    </WindowContext.Provider>
  );
}

export default App;
